import { render, staticRenderFns } from "./Produto.vue?vue&type=template&id=39edc7fc&scoped=true"
import script from "./Produto.vue?vue&type=script&lang=js"
export * from "./Produto.vue?vue&type=script&lang=js"
import style0 from "./Produto.vue?vue&type=style&index=0&id=39edc7fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39edc7fc",
  null
  
)

export default component.exports